import DeleteDialog from './delete-dialog';

export default DeleteDialog;



// WEBPACK FOOTER //
// ./src/client/components/admin/common/delete-dialog/index.js